import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonList, IonItem, IonButton,
    IonInput,
    IonAlert,
    IonIcon,
    IonLoading,
  } from '@ionic/react';
  import React, {useState, useEffect} from 'react';
  import { useParams } from 'react-router';
  import ServerService from '../../../services/Server';
  import { useHistory } from 'react-router-dom';
  import { save, logIn, chevronBack, checkmarkCircle } from 'ionicons/icons';
  import css from "./Account.module.css"
  
  const Account: React.FC = () => {
  
   const { id } = useParams<{ id: string; }>();
   const pageName:string = "Account";
   const history = useHistory();

   const server = new ServerService();
   const state = (id==="-" ? server.defaultAccount : server.accounts[parseInt(id)])
   server.setHistory(history);
   
   const [curId, setCurId] = useState(id);
   const [name, setName] = useState(state.name);
   const [host, setHost] = useState(state.host);
   const [port, setPort] = useState(state.port);
   const [username, setUsername] = useState(state.username);
   const [password, setPassword] = useState(state.password);
   const [customerKey, setCustomerKey] = useState(state.customerKey);
   const [result, setResult] = useState(false);

   const [msg, setMsg] = useState("");
   const [showMsg, setShowMsg] = useState(false);
   const [showLoading, setShowLoading] = useState(false);

   const goBack = () => {
      history.push("/page/settings/accounts")
   }

   const testLoginCallback = (success:boolean) => {
      setShowLoading(false);
      console.log("success:"+success);
      if (success) {
        setMsg("Login Successful");
      }
      setShowMsg(true);
   }

   const loginCallback = (success:boolean, msg:string) => {
    if (success) {
      //window.location.href = server.state.landingUrl;
      window.location.href = "/page/home";
    }
  }

 useEffect(() => {
      setCurId(id);
      setName(state.name);
      setHost(state.host);
      setPort(state.port);
      setUsername(state.username);
      setPassword(state.password);
      setCustomerKey(state.customerKey);
 
      setMsg("Login Successful");
      setShowMsg(false);
 
   }, [state])

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonTitle>{pageName}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={e => goBack()}><IonIcon icon={chevronBack}></IonIcon></IonButton>
          </IonButtons>
          </IonToolbar>
        </IonHeader>
  
        <IonContent>
          <IonHeader collapse="condense">
            <IonToolbar>
              <IonTitle>{pageName}</IonTitle>
            </IonToolbar>
          </IonHeader>
          
          <IonList>
  
            <IonItem>
              <IonInput label="Name" value={name} required={true} className={css.acc_inp} onIonInput={(e: any) => setName(e.target.value)}>
              </IonInput>
            </IonItem>

            <IonItem>
              <IonInput label="Host"value={host} required={true} className={css.acc_inp} onIonInput={(e: any) => setHost(e.target.value)}>
              </IonInput>
            </IonItem>
  
            <IonItem>
              <IonInput label="Port" value={port} type="number" required={true} inputmode="decimal" max="65535" min="80" className={css.acc_inp} onIonInput={(e: any) => setPort(e.target.value)}>
              </IonInput>
            </IonItem>
  
            <IonItem>
              <IonInput label="User" value={username} required={true} className={css.acc_inp} onIonInput={(e: any) => setUsername(e.target.value)}>
              </IonInput>
            </IonItem>
  
            <IonItem>
              <IonInput label="Password" value={password} required={true} type="password" className={css.acc_inp} onIonInput={(e: any) => setPassword(e.target.value)}>
              </IonInput>
            </IonItem>
  
            <IonItem>
              <IonInput label="Customer Key" value={customerKey} required={true} className={css.acc_inp} onIonInput={(e: any) => setCustomerKey(e.target.value)}>
              </IonInput>
            </IonItem>

          </IonList>

          <div className={css.full_width_buttons}>
          <IonButton className="equal_btn" color="success" onClick={(e) => {
                setShowLoading(true);
                server.testLogin({
                  host:host,
                  port:port,
                  username:username,
                  password:password,
                  customerKey:customerKey,
                }, testLoginCallback, setMsg)
            }}>
            <IonIcon icon={checkmarkCircle}/>&nbsp;Test Login
          </IonButton>
  
            <IonButton className="equal_btn" color="primary" onClick={(e) => {
                if (curId==="-") {

                  server.accounts.push({
                    name:name,
                    host:host,
                    port:port,
                    username:username,
                    password:password,
                    customerKey:customerKey
                  });

                  const i = server.accounts.length-1;
                  setCurId(i.toString());

                } else {

                  const i = parseInt(curId);
                  server.accounts[i].name = name;
                  server.accounts[i].host = host;
                  server.accounts[i].port = port;
                  server.accounts[i].username = username;
                  server.accounts[i].password = password;
                  server.accounts[i].customerKey = customerKey;

                }

                server.saveLocal();
                goBack();

            }}>
              <IonIcon icon={save}/>&nbsp;Save
            </IonButton>

            <IonButton className="equal_btn" color="secondary" onClick={(e) => {
                if (curId==="-") {

                  server.accounts.push({
                    name:name,
                    host:host,
                    port:port,
                    username:username,
                    password:password,
                    customerKey:customerKey
                  });

                  const i = server.accounts.length-1;
                  setCurId(i.toString());

                  server.activeAcc = i;
                } else {

                  const i = parseInt(curId);
                  server.accounts[i].name = name;
                  server.accounts[i].host = host;
                  server.accounts[i].port = port;
                  server.accounts[i].username = username;
                  server.accounts[i].password = password;
                  server.accounts[i].customerKey = customerKey;

                  server.activeAcc = i;
                }

                server.saveLocal();

                server.login(loginCallback);

              }}>
              <IonIcon icon={logIn}/>&nbsp;Go
            </IonButton>
            </div>
  <IonAlert
    isOpen={showMsg}
    onDidDismiss={e => {
      setShowLoading(false);
      setShowMsg(false);
      if(result){goBack()}
    }}
    message={msg}
    buttons={['OK']}
  />
  <IonLoading 
    isOpen={showLoading}
    message={'Please wait...'}
  />
        </IonContent>
      </IonPage>
    );
  };
  
  export default Account;
  